/**
 *
 * Created Date: 2019-04-01, 11:00:44 (zhenliang.sun)
 * Last Modified: 2019-08-14, 16:38:58 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */
import { fabric } from 'fabric';
import ToolOption from '../common/ToolOption';
import UndoManager from '../manager/UndoManager';
import { CanvasEventType, GraphName } from './../constants/Constants';
import Graphic from './Graphic';

export default class CanvasArrowBase extends Graphic {
  constructor(app) {
    super(app);
    this._shape = null;
    this._isMouseDown = false;
    this._shouldSend = true;
    this.ox = 0;
    this.oy = 0;

    this.e = {
      mouseDown: this._mouseDownHandler.bind(this),
      mouseMove: this._mouseMoveHandler.bind(this),
      mouseUp: this._mouseUpHandler.bind(this)
    };
  }

  static toAddData(target) {
    let obj = Graphic.toAddData(target);
    obj.fill = null;
    return obj;
  }

  get option() {
    return this._option;
  }

  set option(val) {
    super.option = val;

    if (!val) {
      this._option = this.defaultOption;
    }

    Object.assign(this._option, val);
  }

  get defaultOption() {
    return new ToolOption();
  }

  addEvents() {
    super.addEvents();
    this.root.on(CanvasEventType.MouseDown, this.e.mouseDown);
    this.root.on(CanvasEventType.MouseMove, this.e.mouseMove);
    this.root.on(CanvasEventType.MouseUp, this.e.mouseUp);
  }

  removeEvents() {
    super.removeEvents();
    this.root.off(CanvasEventType.MouseDown, this.e.mouseDown);
    this.root.off(CanvasEventType.MouseMove, this.e.mouseMove);
    this.root.off(CanvasEventType.MouseUp, this.e.mouseUp);
  }

  _mouseDownHandler(o) {
    this._isMouseDown = true;
    // 移除所有监听
    this.items.removeEvents();

    let sp = this.root.getPointer(o.e);
    this.ox = sp.x;
    this.oy = sp.y;
    let path = `M ${this.ox} ${this.oy} L ${this.ox} ${this.oy}`;
    this._shape = new fabric[GraphName.SINGLE_ARROW](path, {
      left: this.ox,
      top: this.oy,
      stroke: this._option.stroke,
      strokeWidth: this._option.strokeWidth,
      fill: null,
      objectCaching: false,
      selectable: false
    });

    this.root.add(this._shape);
  }

  _mouseMoveHandler(o) {}

  _mouseUpHandler(o) {
    this._isMouseDown = false;
    this.items.addEvents();

    if (this._shouldSend === false) {
      return;
    }

    this._shape.setCoords();
    this.root.renderAll();

    let data = this.factory.createAddData(this._shape);
    // MsgSender.add(data)
    this.app.sender.add(data);

    let allData = this.root.toDatalessJSON();
    UndoManager.getInstance().save(allData);
  }
}
